import { render, staticRenderFns } from "./ProductImage.vue?vue&type=template&id=0d419e86&scoped=true&"
import script from "./ProductImage.vue?vue&type=script&lang=ts&"
export * from "./ProductImage.vue?vue&type=script&lang=ts&"
import style0 from "./ProductImage.vue?vue&type=style&index=0&id=0d419e86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d419e86",
  null
  
)

export default component.exports